const frApp = {
    // Analysis page
    matchAnalysisTitle: "Analyse de match",
    enterTeamsSubtitle: "Choisissez les équipes que vous voulez analyser",
    aiNotice: "Notre IA est connectée à l'actualité du football et croise des millions de données pour chaque pronostic",
    matchToAnalyze: "Match à analyser",
    teamSearchPlaceholder: "Rechercher une équipe (PSG, Barcelone, Inter, etc.)",
    teamSearchUnavailable: "La recherche d’équipes est indisponible pour le moment, réessayez dans un instant",
    teamSearchNoResult: "Aucune équipe trouvée avec ce nom",
    versus: "VS",
    analyzeWithAi: "Analyser le match avec l'IA",
    clearSearch: "Effacer",
    backToTeamSearch: "Retour à la recherche d'équipes",
    analysesLeftToday: "{{count}} analyse(s) restante(s) aujourd'hui",

    upcomingMatches: "Matchs à venir",
    upcomingMatchesOf: "Matchs à venir de {{team}}",
    upcomingMatchesBetween: "Matchs à venir entre {{home}} et {{away}}",
    searchingUpcoming: "recherche des matchs à venir",
    pickTeamHint: "Choisissez une équipe pour voir ses prochains matchs",
    notCoveredYet: "{{teams}} n'est pas encore couvert par notre base de pronostics",
    noUpcomingMatch: "Aucun match à venir trouvé",

    // Browsing by competition
    searchByTeams: "Par équipes",
    searchByCompetition: "Par compétition",
    competitionSearchPlaceholder: "Chercher une compétition (Ligue 1, Premier League, etc)",
    competitionSearchNoResult: "Aucune compétition trouvée avec ce nom",
    competitionSearchUnavailable: "Les compétitions sont indisponibles pour le moment, réessayez dans un instant",
    pickCompetitionHint: "Choisissez une compétition pour voir ses matchs à venir",
    upcomingMatchesIn: "Matchs à venir en {{competition}}",
    noUpcomingMatchInCompetition: "Aucun match à venir dans cette compétition",

    // Analysis progress
    matchingTeams: "Identification de {{home}} et {{away}}",
    retrievingPredictions: "Récupération des pronostics IA",
    analysisReady: "Analyse prête",
    crossingData: "Croisement des données des deux équipes, cela prend quelques secondes",
    cancelAnalysis: "Annuler",
    pickBothTeams: "Choisissez les deux équipes avant de lancer l'analyse",
    noExactMatch: "Aucune correspondance exacte pour {{teams}} dans la base de pronostics",
    noUpcomingBetween: "Aucun match à venir entre {{home}} et {{away}}",
    analysisFailed: "L'analyse n'a pas pu aboutir, merci de réessayer",

    // What the API answers when a plan does not cover the analysis
    denialNoSubscriptionTitle: "Une formule est nécessaire",
    denialNoSubscriptionDescription: "Les pronostics IA sont réservés aux abonnés. Choisissez une formule pour lancer votre première analyse.",
    denialExpiredTitle: "Votre accès a expiré",
    denialExpiredDescription: "Votre formule est arrivée à son terme. Renouvelez-la pour retrouver vos pronostics.",
    denialLimitTitle: "Limite du jour atteinte",
    denialLimitDescription: "Vous avez utilisé toutes vos analyses du jour. Elles reviennent à minuit, ou passez à une formule supérieure.",
    denialResetAt: "Prochaines analyses à {{time}}",
    seePlans: "Voir les formules",

    // Prediction panel
    panelHome: "DOMICILE",
    panelAway: "EXTÉRIEUR",
    panelDraw: "NUL",
    panelWin: "VICTOIRE",
    panelConfidenceHigh: "CONFIANCE ÉLEVÉE",
    panelConfidenceMedium: "CONFIANCE MOYENNE",
    panelConfidenceLow: "CONFIANCE FAIBLE",
    panelBtts: "LES 2 MARQUENT",
    panelFirstHalf: "1RE MI-TEMPS",
    panelFirstScorer: "1ER BUTEUR",
    panelGoals: "BUTS",
    panelExactScore: "SCORE EXACT",
    panelRecommendedBets: "PARIS RECOMMANDÉS",
    panelAiReasoning: "ANALYSE DE L'IA",
    panelYes: "Oui",
    panelNo: "Non",
    panelNeither: "Aucune",
    panelTotal: "TOTAL",
    panelStatusScheduled: "PROGRAMMÉ",
    panelStatusLive: "EN DIRECT",
    panelStatusFinished: "TERMINÉ",
    panelStatusCanceled: "ANNULÉ",
    panelStatusTbd: "À VENIR",
    betMatchWinner: "Vainqueur du match",
    betTotalGoals: "Total de buts",
    betHomeGoals: "Buts à domicile",
    betAwayGoals: "Buts à l'extérieur",
    betBothTeamsScore: "Les deux équipes marquent",
    betFirstHalfWinner: "Vainqueur 1re mi-temps",
    betFirstToScore: "Première équipe à marquer",
    betExactScore: "Score exact",
    betGoalsSuffix: "Buts",
    panelNoPrediction: "Aucun pronostic disponible pour ce match",

    // History
    historyTitle: "Historique",
    historySubtitle: "Tous les matchs que vous avez analysés",
    historyNotice: "Vos analyses sont conservées sur cet appareil, en rouvrir une ne consomme pas d'analyse",
    noAnalysisYet: "Aucune analyse pour l'instant",
    noAnalysisYetDescription: "Les matchs que vous analysez apparaissent ici, avec tout leur panneau de pronostics.",
    analyzeAMatch: "Analyser un match",
    savedAnalyses: "{{count}} analyse(s) enregistrée(s)",
    filterPlaceholder: "Filtrer par équipe ou compétition",
    noAnalysisMatches: "Aucune analyse ne correspond à « {{query}} »",
    analyzedOn: "Analysé le {{date}}",
    showAnalysis: "Afficher l'analyse",
    hideAnalysis: "Masquer l'analyse",
    removeFromHistory: "Retirer de l'historique",

    // Account
    profile: "Profil",
    displayName: "Nom affiché",
    yourNamePlaceholder: "Votre nom",
    emailLabel: "E-mail",
    emailNotice: "Votre e-mail identifie votre compte et ne peut pas être modifié ici. Contactez le support si besoin.",
    memberSince: "Membre depuis le {{date}}",
    emailAndPassword: "E-mail et mot de passe",
    googleLabel: "Google",
    planSuffix: "Formule {{plan}}",
    yourPlan: "Votre formule",
    analysesUsedToday: "Analyses utilisées aujourd'hui",
    dailyLimitReached: "Limite quotidienne atteinte, elle repart demain",
    leftUntilTomorrow: "{{count}} restante(s) jusqu'à demain",
    renewsOn: "Se termine le",
    endedOn: "Terminée le",
    seeAllPlans: "Voir toutes les formules",
    upgradeMyPlan: "Choisir une formule",
    security: "Sécurité",
    changePasswordNotice: "Changez votre mot de passe. L'actuel est demandé pour confirmer que c'est bien vous.",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    changePassword: "Changer le mot de passe",
    googleAccountNotice: "Vous vous connectez avec Google, votre mot de passe est géré par votre compte Google.",
    setPasswordNotice: "Vous vous connectez avec Google. Définissez un mot de passe pour aussi vous connecter avec votre e-mail et ce mot de passe.",
    setPassword: "Définir le mot de passe",
    passwordSet: "Votre mot de passe a été défini, vous pouvez maintenant vous connecter avec votre e-mail",
    nameEmpty: "Votre nom ne peut pas être vide",
    nameUpdated: "Votre nom a été mis à jour",
    passwordChanged: "Votre mot de passe a été changé",
    passwordTooShort: "Votre nouveau mot de passe doit faire au moins {{min}} caractères",
    statusActive: "active",
    statusExpired: "expirée",
    statusCancelled: "annulée",
    statusPaused: "en pause",

    // Referrals
    inviteFriends: "Invitez vos amis",
    referralPitch: "Ils obtiennent {{referred}}% sur leur première formule, vous obtenez {{referrer}}% sur votre prochain paiement pour chaque ami qui s'inscrit.",
    yourCode: "Votre code",
    referralCodeCopied: "Code de parrainage copié",
    invitationLinkCopied: "Lien d'invitation copié",
    copyUnavailable: "La copie est indisponible, sélectionnez le texte manuellement",
    friendsJoined: "Amis inscrits",
    creditsAvailable: "Crédits disponibles",
    offNextPayment: "Sur le prochain paiement",
    yourDiscounts: "Vos réductions",
    usedOn: "Utilisé le {{date}}",
    validUntil: "Valable jusqu'au {{date}}",
    noOneUsedCode: "Personne n'a encore utilisé votre code. Partagez le lien ci-dessus pour gagner des réductions.",
    creditOriginReferrer: "Ami invité",
    creditOriginReferred: "Bonus de bienvenue",
    creditStatusAvailable: "disponible",
    creditStatusConsumed: "utilisé",
    creditStatusExpired: "expiré",
    percentOff: "{{percent}}% de réduction"
}

export default frApp
